export default __webpack_public_path__ + "img/eHvMsrdJ.7edb04cc.svg";